/**
 * DIBAI 18K — Números (contador animado)
 * assets/numeros-dibai.js  v1.0.0
 */
(function () {
  'use strict';

  function animateCounter(el, target, suffix, duration) {
    const start   = performance.now();
    const suffix_ = suffix || '';

    function format(n) {
      return n.toLocaleString('es-CO') + suffix_;
    }

    function step(now) {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Easing: ease-out cubic
      const eased    = 1 - Math.pow(1 - progress, 3);
      const current  = Math.round(eased * target);
      el.textContent = format(current);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function init(root) {
    const numbers = Array.from(root.querySelectorAll('[data-num-target]'));
    if (!numbers.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el     = entry.target;
        const target = parseInt(el.dataset.numTarget, 10) || 0;
        const suffix = el.dataset.numSuffix || '';
        animateCounter(el, target, suffix, 2000);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });

    numbers.forEach(n => observer.observe(n));
  }

  function initAll() {
    document.querySelectorAll('.numeros-dibai-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.numeros-dibai-wrapper') || e.target.closest('.numeros-dibai-wrapper');
    if (root) init(root);
  });
})();
